import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { OnboardingComponent } from '../../../shared/components/onboarding/onboarding.component';
import { CentralService } from "../../../services/central.service";
import { Observable, Observer, Operator, Subscription } from 'rxjs';
import { jwtDecode } from "jwt-decode";
import { Listado } from '../../../services/listado.service';
import { environment } from '../../../environments/enviroment';


@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterOutlet, 
    RouterLink, 
    RouterLinkActive,
    CommonModule,
    OnboardingComponent ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit, OnDestroy{

  @Input() logged: boolean = false;

  nombreUsuario : string  = '';
  idUsuario     : string  = '';
  onBoarding    : boolean = false;
  // usuarioRepresentante:boolean = true;
  showOnboarding: boolean = false;
  array_rolUsuario: string[] = [];
  contenidoEspecial: string = '';
  hasAvailableShorts: boolean = false;
  readonly shortsEnabled = environment.shortsEnabled;

  constructor (
    private centralServ:CentralService,
    private listadoService: Listado){}


  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  subscriptions: Subscription[] = [];



  puedeRegistrar(usuario:any){
    if (usuario.UserTypeArray[0] == 'Representante' || this.centralServ.whiteList.includes(usuario.email)) {  
      return true;
    }
    return false;  
  }

  permisoRegistrar : boolean = false
  
  private getTokenRoles(): string[] {
    const token = localStorage.getItem('token');
    if (!token) return [];

    try {
      const decoded: any = jwtDecode(token);
      const tokenRoleFields = [
        decoded?.UserTypeArray,
        decoded?.role,
        decoded?.roles,
        decoded?.authorities,
        decoded?.usertype,
        decoded?.user_type,
        decoded?.userTypeArray,
        decoded?.user_type_array,
        decoded?.userTypes,
        decoded?.userType
      ];

      return this.extractRoleTokens(tokenRoleFields);
    } catch {
      return [];
    }
  }

  private normalizeRole(value: string): string {
    return (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\s_-]+/g, '')
      .trim()
      .toLowerCase();
  }

  private extractRoleTokens(value: any): string[] {
    if (Array.isArray(value)) {
      return value.flatMap(item => this.extractRoleTokens(item));
    }

    if (value && typeof value === 'object') {
      return Object.values(value).flatMap(item => this.extractRoleTokens(item));
    }

    if (typeof value === 'string') {
      const raw = value.trim();
      if (!raw) return [];

      try {
        const parsed = JSON.parse(raw);
        if (parsed !== value) {
          return this.extractRoleTokens(parsed);
        }
      } catch {
        // no-op
      }

      return raw.match(/[A-Za-zÁÉÍÓÚáéíóúÑñ]+/g) || [];
    }

    return [];
  }

  private getAllRoles(): string[] {
    const sources = [
      this.array_rolUsuario,
      this.centralServ.usuario?.UserTypeArray,
      localStorage.getItem('userTypeArray'),
      this.getTokenRoles()
    ];

    return sources
      .flatMap(source => this.extractRoleTokens(source))
      .map(role => this.normalizeRole(role))
      .filter(role => role.length > 0);
  }

  shouldShowCapsulas(): boolean {
    if (!this.logged) return false;
    if (window.location.pathname === '/') return false;

    const currentRoles = this.getAllRoles();
    if (!currentRoles.length) return false;

    const blockedRoles = new Set([
      'representantelatam',
      'medicolatam'
    ]);

    const hasBlockedRole = currentRoles.some(role => blockedRoles.has(role));

    return !hasBlockedRole;
  }

  shouldShowPuntoCima(): boolean {
    return this.logged
      && this.centralServ.isPuntoCimaUser([
        this.array_rolUsuario,
        this.getTokenRoles()
      ]);
  }


  ngOnInit(): void {
    const usuarioSubscription = this.centralServ.usuario$.subscribe(usuario => {
      if (usuario) {
        this.nombreUsuario = usuario.nombre;
        this.idUsuario = usuario._id;
        this.onBoarding = usuario.verOnboarding;
        this.array_rolUsuario = usuario.UserTypeArray || [];
        this.permisoRegistrar = this.puedeRegistrar(usuario);

        if (this.shortsEnabled) {
          const shortsAvailabilitySubscription = this.listadoService
            .hasAvailableShorts(usuario._id)
            .subscribe(hasAvailableShorts => {
              this.hasAvailableShorts = hasAvailableShorts;
            });

          this.subscriptions.push(shortsAvailabilitySubscription);
        } else {
          this.hasAvailableShorts = false;
        }

        if (usuario.verOnboarding && this.checkIfSessionIsActive()) {
          this.runOnboarding();
        }
      } else {
        this.hasAvailableShorts = false;
      }
    });
    const contenidoEspecialSubscription = this.centralServ.contenidoEspecial$.subscribe((contenidoEsp: any) => {
      this.contenidoEspecial = contenidoEsp || '';
    });
    
    this.subscriptions.push(usuarioSubscription, contenidoEspecialSubscription);
  }

  runOnboarding(){
    this.showOnboarding = true;
  }

  toggleOnboarding(evt:boolean){  
    this.showOnboarding = evt;
  }

  checkIfSessionIsActive(): boolean {
    const token = localStorage.getItem('token');
    return token !== null && token !== undefined;
  }
}
